import { definePreset, ThemeOptions } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

export const primePreset: ThemeOptions = definePreset(Aura, {
  semantic: {
    primary: {
      primary: {
        0: '#03619C',
        100: '#d4e6fa',
        200: '#8db9ec',
        300: '#46A8E1',
        400: '#007aff',
        500: '#03619C',
        600: '#03567A',
        700: '#02455A',
        800: '#013545',
        900: '#012132',
        950: '#011F2B',
      },
    },
    colorScheme: {
      light: {
        primary: {
          color: '#03619C',
          contrastColor: '#FFFFFF',
          hoverColor: '#1d92c4',
          activeColor: '#02455A',
        },
        surface: {
          ground: '#f3f6fb',
        },
      },
      dark: {
        surface: {
          ground: '#27272a',
          section: '#1e293b',
        },
      },
    },
  },
})
